import {type TranslationObject} from '@colonist/i18n'
import {type BigId, type LobbyImage} from '@colonist/types'
import {type FriendRoomInviteNotificationData, type FriendStatusData, type RoomInviteResponse} from '../../../../shared/friends/FriendTypes.ts'
import {UIOnlineFriendController} from '../../../shared/scripts/ui_friends/UIOnlineFriendController.ts'
import {UICornerNotificationController} from '../ui_corner_notification/UICornerNotificationController.ts'
import {type UIRoomController} from '../ui_html/room/UIRoomController.ts'
import {UIUrlController} from '../../../shared/scripts/ui_html/UIUrlController.ts'
import {type UINotificationPanelController} from '../../../shared/scripts/notifications/UINotificationPanelController.ts'

export class UIWOnlineFriendController extends UIOnlineFriendController {
    private readonly roomController: UIRoomController | undefined

    constructor(roomController: UIRoomController | undefined, notificationPanelController: UINotificationPanelController | undefined) {
        super(notificationPanelController)
        this.roomController = roomController
    }

    updateFriendOnlineStatus(friendData: FriendStatusData) {
        this.roomController?.updateFriendOnlineStatus(friendData)
        super.updateFriendOnlineStatus(friendData)
    }

    updateAllFriendsOnlineStatus(friends: FriendStatusData[]) {
        this.roomController?.updateAllFriendsOnlineStatus(friends)
        super.updateAllFriendsOnlineStatus(friends)
    }

    friendRespondedToRoomInvite(responseData: RoomInviteResponse) {
        if(responseData.response) return
        super.friendRespondedToRoomInvite(responseData)
        if(UIUrlController.getRoomIdFromUrl() != responseData.roomId.toLocaleLowerCase()) return
        this.roomController?.toggleFriendInviteButtonState(responseData.responderUserId, true)
    }

    roomInviteSentToFriendSuccessfully(receiverUserId: BigId) {
        const roomId = UIUrlController.getRoomIdFromUrl()
        if(!roomId) return
        this.roomController?.toggleFriendInviteButtonState(receiverUserId, false)
    }

    // eslint-disable-next-line class-methods-use-this
    showNotification(icon: LobbyImage, translationObj: TranslationObject) {
        UICornerNotificationController.showNotification(icon, translationObj)
    }

    showJoinRoomNotification(icon: LobbyImage, translationObj: TranslationObject, roomInvite: FriendRoomInviteNotificationData) {
        this.showNotification(icon, translationObj)
    }
}
